<div 
    #scrollContainer
    class="!mt-5 flex flex-col !gap-5 max-h-[520px] overflow-y-auto activity-scroll"
    (scroll)="onScroll()">
    <ng-container *ngIf="histories?.length">
        <ng-container *ngFor="let history of histories">
            <div class="flex !gap-3">
                <img class="h-[40px] min-h-[40px] w-[40px] min-w-[40px] rounded-full"
                    src="{{ baseUrl }}/storage/files/web/{{history?.user?.avatar_thumbnail_url}}.webp"
                    (error)="replaceWithDefaultImage($event)"
                    alt="Avatar"
                />
                <div>
                    <p class="flex flex-wrap !gap-1 text-sm text-palette-gray-900">
                        <span class="font-semibold">{{ history.user.full_name }}</span>
                        <span *ngIf="history.mode == 0">{{ 'COMMON.CREATED' | translate }}</span>
                        <span class="font-semibold">{{ history.action | translate }}</span>
                        <ng-container *ngIf="history?.module">
                            <span>{{ 'COMMON.FOR' | translate }}</span>
                            <span class="font-semibold">{{ history?.module | translate }}</span>
                        </ng-container>
                    </p>
                    <p class="text-xs text-palette-gray-500 !mt-1">{{ history.created_at | dateFormat: true }}</p>
                    
                    <div *ngIf="history?.detail" class="flex">
                        <ng-container *ngIf="history?.mode != 2">
                            <div *ngIf="getType(history.detail) !== 'string'" class="flex-1 !py-1 !px-2 rounded-lg bg-palette-gray-100 !mt-2">
                                <div *ngFor="let segment of history?.detail; let first = first" class="text-sm font-medium text-palette-gray-900"
                                    [ngClass]="{ 'border-t border-palette-gray-200': !first }">
                                    <p *ngIf="segment?.label" class="{{segment?.labelBold ? 'font-semibold' : ''}}">{{ segment.label }}</p>
                                    <div *ngIf="segment?.data" class="!mt-[2px]">
                                        <div *ngFor="let item of segment.data" class="flex items-center !gap-1">
                                            <p *ngIf="item?.title">{{ item.title }}: </p>
                                            <p *ngIf="item?.value">{{ item.value }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="getType(history.detail) === 'string'" class="w-fit !py-1 !px-2 rounded-lg bg-palette-gray-100 !mt-2 whitespace-pre-line">
                                <p class="text-sm text-palette-gray-900 break-all">
                                    {{ getVisibleText(history.id, history.detail) }}
                                </p>

                                <!-- VIEW MORE -->
                                <button
                                    *ngIf="shouldShowToggle(history.detail) && !isFullyExpanded(history.id, history.detail)"
                                    class="text-sm text-palette-blue-600 font-medium mt-1 hover:text-palette-blue-500 min-w-[80px] text-left"
                                    (click)="expandMore(history.id, history.detail)"
                                >
                                    {{ 'COMMON.VIEW_MORE' | translate }}
                                </button>

                                <!-- SHOW LESS -->
                                <button
                                    *ngIf="shouldShowToggle(history.detail) && isFullyExpanded(history.id, history.detail)"
                                    class="text-sm text-palette-blue-600 font-medium mt-1 hover:text-palette-blue-500 min-w-[80px] text-left"
                                    (click)="showLess(history.id, history.detail)"
                                >
                                    {{ 'COMMON.SHOW_LESS' | translate }}
                                </button>
                            </div>
                        </ng-container>
                        <a *ngIf="history?.mode == 2"
                            [href]="history.detail"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="text-palette-blue-600 text-sm font-semibold hover:text-palette-blue-500 !mt-2">
                            {{ 'COMMON.VIEW_DETAILS' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <!-- Skeleton -->
    <ng-container *ngIf="isLoading">
        <div *ngFor="let i of [1, 2, 3]" class="flex !gap-3 animate-pulse">
            <div class="h-[40px] w-[40px] rounded-full bg-palette-gray-200"></div>
            <div class="flex-1 space-y-2">
                <div class="h-3 bg-palette-gray-200 rounded w-[80%]"></div>
                <div class="h-3 bg-palette-gray-200 rounded w-[60%]"></div>
                <div class="h-3 bg-palette-gray-200 rounded w-[50%]"></div>
            </div>
        </div>
    </ng-container>
    <!-- No Item -->
    <ng-container *ngIf="!histories?.length && !isLoading">
        <p class="text-sm font-medium text-palette-gray-500 italic !pl-2">
            {{ 'COMMON.NO_ACTIVITY_HISTORY' | translate }}
        </p>
    </ng-container>
</div>